'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _legacyI18nInit = require('../internal/legacyI18nInit');

var _hsIntl = require('../internal/hs-intl');

var _localeMapper = require('../internal/localeMapper');

var _localeMapper2 = _interopRequireDefault(_localeMapper);

var _localStorage = require('../internal/localStorage');

var localStorage = _interopRequireWildcard(_localStorage);

var _localeCacheKeys = require('../internal/localeCacheKeys');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = function (options) {
  var intl = (0, _hsIntl.create)();

  var _setLocale = intl.setLocale,
      _register = intl.register,
      rest = _objectWithoutProperties(intl, ['setLocale', 'register']);

  var localesToLoad = [];

  var I18nProvider = _extends({
    register: function register(lang) {
      var registerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var mapper = registerOptions.localeMapper || _localeMapper2.default;
      var p = _register.call(intl, lang, _extends({}, registerOptions, {
        localeMapper: function localeMapper() {
          var l = mapper.apply(undefined, arguments);
          if (l && !localesToLoad.includes(l)) {
            localesToLoad.push(l);
          }
          return l;
        }
      }));
      p.then(function () {
        if (!options || options.__localesCacheKey !== _localeCacheKeys.PUBLIC_CACHE) {
          localStorage.setItem(options && options.__localesCacheKey || _localeCacheKeys.STANDARD_CACHE, JSON.stringify(localesToLoad));
        }
      });
      return p;
    },
    setLocale: function setLocale(_ref) {
      var locale = _ref.locale,
          langEnabled = _ref.langEnabled,
          timezone = _ref.timezone;

      (0, _legacyI18nInit.setManualOverwrites)();
      (0, _legacyI18nInit.setupTimezone)(timezone);

      I18n.locale = I18n.manualLocale || (0, _legacyI18nInit.getValidLocale)(locale);
      I18n.langEnabled = !!I18n.manualLocale || langEnabled;

      var loaderLocales = I18n.langEnabled ? [I18n.locale] : [];
      if (!I18n.langEnabled && I18n.locale === _legacyI18nInit.defaultLanguage) {
        // We still set new users to en instead of en-us if they have never changed their settings
        // We need to load en-us number formats
        loaderLocales.push('en-us');
      }

      var shouldLoadFallback = !(options && options.excludeFallback);
      if (shouldLoadFallback) {
        loaderLocales.push(_legacyI18nInit.defaultLanguage);
      }

      I18n.fired.ready = true;
      I18n.Info.resolve({
        locale: I18n.locale,
        langEnabled: I18n.langEnabled,
        timezone: I18n.timezone
      });

      if (I18n.moment) {
        var validMomentLocale = _legacyI18nInit.momentMappings[I18n.locale] || _legacyI18nInit.momentMappings[I18n.locale.split('-')[0]] || _legacyI18nInit.defaultLanguage;
        I18n.moment.locale(validMomentLocale);
      }

      return _setLocale(loaderLocales);
    }
  }, rest);

  return I18nProvider;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/js/init/providers/createStandardI18nProvider.js
// module id = 130
// module chunks = 177 178